<div>
  <p [className]="classNames">{{title}}</p>
  <p [className]="classNames">{{description}}</p>
  <aux-divider></aux-divider>
</div>
